import { modalRoutes } from 'constants/routes';

function parseHashSegments(hash: string): string[] {
  return hash
    .replace('#', '')
    .split('/')
    .filter((segment) => !!segment);
}

export function resolvePostModalHashForPreference(
  hash: string,
  isNewPostExperienceActive: boolean,
): string | null {
  const [rootSegment, ...restSegments] = parseHashSegments(hash);

  if (!rootSegment) {
    return null;
  }

  const preferredSegment = isNewPostExperienceActive
    ? modalRoutes.POST_DETAIL_NEW
    : modalRoutes.POST_DETAIL;
  const staleSegment = isNewPostExperienceActive
    ? modalRoutes.POST_DETAIL
    : modalRoutes.POST_DETAIL_NEW;

  if (rootSegment !== staleSegment) {
    return null;
  }

  return `#${[preferredSegment, ...restSegments].join('/')}`;
}
